import React, { Component } from 'react';
interface IDatePublishProps {
    creationDate: Date;
    editionDate: Date;

    dictToday: string;
    dictEdited: string;
    dictPublished: string;
    dictYesterday: string;
    dictDaysAgo: string;
    dictWeeksAgo: string;
    dictWeekAgo: string;
    dictMonthsAgo: string;
    dictMonthAgo: string;
    dictYearsAgo: string;
    dictYearAgo: string;
}
interface IDatePublishState {
    relativeDate: string;
}

export class DatePublish extends Component<
    IDatePublishProps,
    IDatePublishState
> {
    constructor(props: any) {
        super(props);

        this.state = {
            relativeDate: '',
        };
    }

    public componentDidMount(): void {
        this.setState({
            relativeDate: this.convertToLabelDate(
                this.props.editionDate,
                this.props.creationDate
            ),
        });
    }

    private convertToLabelDate(editionDate: Date, creationDate: Date): string {
        const currentDate = new Date(new Date().toDateString()).getTime();
        const date = editionDate > creationDate ? editionDate : creationDate;
        const diffInMs =
            currentDate - new Date(new Date(date).toDateString()).getTime();
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        if (diffInDays < 7) {
            return diffInDays < 1
                ? this.props.dictToday
                : diffInDays === 1
                  ? this.props.dictYesterday
                  : this.props.dictDaysAgo.replace('%s', diffInDays.toString());
        }

        const diffInWeeks = Math.floor(diffInDays / 7);
        if (diffInWeeks < 4) {
            return diffInWeeks <= 1
                ? this.props.dictWeekAgo
                : this.props.dictWeeksAgo.replace('%s', diffInWeeks.toString());
        }

        const diffInMonths = Math.floor(diffInDays / 30);
        if (diffInMonths < 12) {
            return diffInMonths <= 1
                ? this.props.dictMonthAgo
                : this.props.dictMonthsAgo.replace(
                      '%s',
                      diffInMonths.toString()
                  );
        }

        const diffInYears = Math.floor(diffInDays / 365);
        return diffInYears <= 1
            ? this.props.dictYearAgo
            : this.props.dictYearsAgo.replace('%s', diffInYears.toString());
    }

    render() {
        return (
            <span className="datePublish">
                {new Date(new Date(this.props.editionDate).toDateString()) >
                    new Date(
                        new Date(this.props.creationDate).toDateString()
                    ) &&
                    this.props.dictEdited.replace(
                        '%s',
                        this.state.relativeDate
                    )}
                {new Date(new Date(this.props.editionDate).toDateString()) <=
                    new Date(
                        new Date(this.props.creationDate).toDateString()
                    ) &&
                    this.props.dictPublished.replace(
                        '%s',
                        this.state.relativeDate
                    )}
            </span>
        );
    }
}
